import CalendarTable from "../../components/CalendarTable";

export default function CalenderHistory({ data, openRecords }) {
  return (
    data.ID > 0 && (
      <div
        style={{
          position: "absolute",
          bottom: 10,
          backgroundColor: "white",
          left: 10,
          right: 10,
        }}
        onClick={() => openRecords(data.ID, data.NOM)}
      >
        <CalendarTable data={data.HISTORIAL} />
      </div>
    )
  );
}
